function readCookie(name: string): string | undefined {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\/+^])/g, '\\$1') + '=([^;]*)'))
  return match ? decodeURIComponent(match[1]) : undefined
}

export function getCsrfToken(): string | undefined {
  const meta = document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null
  if (meta?.content) return meta.content
  // Common cookie names used by Django/DRF or CSRF middlewares
  const fromCookie = readCookie('csrftoken') || readCookie('csrf_token') || readCookie('XSRF-TOKEN')
  if (fromCookie && meta) meta.content = fromCookie
  return fromCookie
}

